import LoadingOutlined from "@ant-design/icons/LoadingOutlined";

import { Empty } from "./styles";

type NotFoundComponentProps = {
  loading?: boolean;
};

export const NotFoundComponent = ({
  loading = false,
}: NotFoundComponentProps) => {
  return (
    <Empty
      loading={loading}
      image={
        loading && (
          <LoadingOutlined
            style={{
              fontSize: "48px",
              color: "rgba(0,0,0,0.45)",
            }}
            spin
          />
        )
      }
      description={loading ? "Carregando..." : undefined}
    />
  );
};
